export function LockFilled({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 8.675C6.45011 8.675 6.815 8.31011 6.815 7.86C6.815 7.40989 6.45011 7.045 6 7.045C5.54989 7.045 5.185 7.40989 5.185 7.86C5.185 8.31011 5.54989 8.675 6 8.675Z"
          fill="currentColor"
        />
        <path
          d="M9.14 4.765V4.14C9.14 2.79 8.815 1 6 1C3.185 1 2.86 2.79 2.86 4.14V4.765C1.46 4.94 1 5.65 1 7.395V8.325C1 10.375 1.625 11 3.675 11H8.325C10.375 11 11 10.375 11 8.325V7.395C11 5.65 10.54 4.94 9.14 4.765ZM6 9.37C5.165 9.37 4.49 8.69 4.49 7.86C4.49 7.025 5.17 6.35 6 6.35C6.83 6.35 7.51 7.03 7.51 7.86C7.51 8.695 6.835 9.37 6 9.37ZM3.675 4.72C3.635 4.72 3.6 4.72 3.56 4.72V4.14C3.56 2.675 3.975 1.7 6 1.7C8.025 1.7 8.44 2.675 8.44 4.14V4.725C8.4 4.725 8.365 4.725 8.325 4.725H3.675V4.72Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
